__turbopack_context__.v({
  "banner": "cookie-banner-module__1CPR9q__banner",
  "buttons": "cookie-banner-module__1CPR9q__buttons",
  "text": "cookie-banner-module__1CPR9q__text",
});
